import Fuse from "fuse.js";
import { Product } from "../types/product";

export const searchArrayOfProducts = (
    searchValue: string,
    products: Array<Product>
) => {
    const fuse = new Fuse(products, {
        threshold: 0.2,
        keys: ["id", "properties.name.en", "properties.name.th"],
    });
    const results = fuse.search(searchValue).map((result) => result.item);
    return results as Array<Product>;
};
